<script>
	const utilities = require('utilities');

	/**
	 * This is a list of images that launches the vocabulary-image-modal
	 */
	module.exports = {
		props: {
			images: {
				required: true,
				default: null
			},
			word: {
				type: String,
				default: null
			},
			onImageClick: {
				type: Function,
				default() {}
			}
		},
		methods: {
			imageClickHandler(imageInfo) {
				this.onImageClick(imageInfo);
				this.openVocabImageModal(imageInfo);
			},
			openVocabImageModal(imageInfo) {
				let word = this.word;
				utilities.openModal('#vocabulary-image-modal', {
					imageInfo,
					word
				});
			}
		}
	};
</script>
<style lang="scss">
	@import 'config/colors';

	.vocabulary-image-list {
		.image-thumb {
			height: 8rem;
			width: 8rem;
			margin: 0.5rem;
			border: 2px solid transparent;
			display: inline-block;
			cursor: pointer;
			transition: all 0.2s;
			&:hover {
				border-color: $c-blue;
				background: $c-blue;
			}
			img {
				background-repeat: no-repeat;
				background-size: cover;
				background-position: center;
				height: 100%;
				width: 100%;
			}
		}
	}
</style>
<template>
	<div class="vocabulary-image-list">
		<span
			v-for="image in images"
			:key="image.thumbUrl"
			class="image-thumb"
			@click="imageClickHandler(image)">
			<img :src="image.thumbUrl" />
		</span>
	</div>
</template>
